import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LoginToWebChatSystem } from "../services/api";
import Unauthorized from "../components/Unauthorized";
import EventScribeSpinner from "../components/shared/EventScribeSpinner";
import StorageService from "../utils/StorageService";
import { useAuth } from "../context/AuthContext";
import { useAppEnv } from "../context/AppEnvContext"; 
import { useChatStore } from "../store/useChatStore";
import { API_URLS } from "../constants/apiUrls";
import { AUTH_FLOWS } from "../constants/Session";
const setPrimaryUserId = useChatStore.getState().setPrimaryUserId;
const setSecondaryUserId = useChatStore.getState().setSecondaryUserId;
const AuthGuard = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
 
  const { setAuthData } = useAuth(); // Access the context setter
  const { token } = useParams(); // Call useParams at the top level
  const env = useAppEnv();
  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        if (!token) {
          throw new Error("Invalid request");
        }
        const _guard_ = StorageService.get("_guard_");
        if (_guard_ !== token) {
          // Clear old data and update with new accountId
          StorageService.clear();
          StorageService.set("_guard_", token);
        }

        // Call LoginToWebChatSystem API
 
          const loginResponse = await LoginToWebChatSystem({
              url: API_URLS.LOGIN,
          data: token,
          domain: env.REACT_APP_DOMAIN
        });
        if (!loginResponse || !loginResponse.AccessToken) {
          throw new Error("Login failed");
        }

        // Store the data in context
          setAuthData({
              clientId:
                  loginResponse.ClientID && Number(loginResponse.ClientID) > 0
                      ? loginResponse.ClientID
                      : null,
              eventId:
                  loginResponse.EventID && Number(loginResponse.EventID) > 0
                      ? loginResponse.EventID
                      : null,
              accountId1:
                  loginResponse.AccountID && Number(loginResponse.AccountID) > 0
                      ? loginResponse.AccountID
                      : null,
              accountId2:
                  loginResponse.AccountIDTo && Number(loginResponse.AccountIDTo) > 0
                      ? loginResponse.AccountIDTo
                      : null,
              accessToken: loginResponse.AccessToken,
              _guard_: token,
              systemToken: loginResponse.AccessToken,
              refreshToken: loginResponse.RefreshToken || null,
              accessTokenExpiresAt: loginResponse.AccessTokenExpiresAt || null,
              authFlow: AUTH_FLOWS.CHAT_LINK,
              // Kept on authData so the chat-link re-login renewer can run from
              // a service module without reading process.env itself.
              domain: env.REACT_APP_DOMAIN,
          });

          if (
              loginResponse.ClientID &&
              loginResponse.EventID &&
              loginResponse.AccountID &&
              Number(loginResponse.ClientID) > 0 &&
              Number(loginResponse.EventID) > 0 &&
              Number(loginResponse.AccountID) > 0
          ) {
              setPrimaryUserId(`${loginResponse.EventID}_${loginResponse.ClientID}_${loginResponse.AccountID}`);
              if (loginResponse.AccountIDTo && Number(loginResponse.AccountIDTo) > 0) {
                  setSecondaryUserId(`${loginResponse.EventID}_${loginResponse.ClientID}_${loginResponse.AccountIDTo}`);
              } else {
                  setSecondaryUserId(null);
              }
          } else {
              setPrimaryUserId(null);
              setSecondaryUserId(null);
          }
         
        setAuthorized(true);
      } catch (error) {
        console.error("Unauthorized:", error);
        setAuthorized(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuthorization();
  }, [location, setAuthData]);

  if (loading) {
    return <EventScribeSpinner logovisible={true} />;
  }

  if (!authorized) {
    return <Unauthorized />;
  }


  return <>{children}</>;
};

export default AuthGuard;
